import { render, staticRenderFns } from "./Blacklists.vue?vue&type=template&id=1d90e2d4&scoped=true"
import script from "./Blacklists.vue?vue&type=script&lang=js"
export * from "./Blacklists.vue?vue&type=script&lang=js"
import style0 from "./Blacklists.vue?vue&type=style&index=0&id=1d90e2d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90e2d4",
  null
  
)

export default component.exports